// extracted by mini-css-extract-plugin
export default {"innerWrapper":"innerContent_innerWrapper__3XHoi","shortDescription":"innerContent_shortDescription__Ta8jo"};